<template>
  <div class="mainContainer">
    <nav-bar />

    <div class="innerContainer">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: jumpPath }">{{
          listName
        }}</el-breadcrumb-item>
        <el-breadcrumb-item>详情页</el-breadcrumb-item>
      </el-breadcrumb>
      <el-dropdown v-if="noAudit && !$route.query.isMyAudit">
        <el-button size="small" type="primary">
          操作<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-if="
              !$route.query.isAudit &&
              detail['n_release_status'] !== null &&
              detail['n_release_status'] != 2 &&
              detail['n_release_status'] != 4 &&
              !$route.query.isPost
            "
            @click.native="toEdit"
            >修改</el-dropdown-item
          >
          <el-dropdown-item
            v-if="detail.status != 0 && $route.query.isPost"
            @click.native="toEditPost"
            >修改</el-dropdown-item
          >
          <el-dropdown-item
            v-if="
              detail['n_release_status'] == 5 &&
              detail['nm_clock_is_send'] == 0 &&
              detail['nm_clock_time']
            "
            ><span @click="pubNow" class="scriptDrop"
              >立即发布</span
            ></el-dropdown-item
          >
          <el-dropdown-item
            v-if="!$route.query.isAudit && !$route.query.isPost"
            @click.native="toDelete"
            >删除</el-dropdown-item
          >
          <el-dropdown-item
            v-if="$route.query.isPost"
            @click.native="toDeletePost"
            >删除</el-dropdown-item
          >
          <el-dropdown-item
            v-if="
              (detail['n_release_status'] == 1 ||
                detail['n_release_status'] == 2 ||
                detail['n_release_status'] == 4 ||
                (!detail['n_release_status'] && !$route.query.draftId)) &&
              !$route.query.isAudit &&
              !$route.query.isPost
            "
            @click.native="cancelAudit"
            >撤回</el-dropdown-item
          >
          <el-dropdown-item
            v-if="$route.query.isAudit"
            @click.native="handleAudit('INTERNAL_SUCCESS')"
            >通过</el-dropdown-item
          >
          <el-dropdown-item
            v-if="$route.query.isAudit"
            @click.native="handleAudit('INTERNAL_FAIL')"
            >不通过</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
      <div class="detailInfoContainer" v-if="detail[nameSuffix + 'title']">
        <p class="title status">
          <span
            :class="convertStatusStyle(detail['n_release_status'])"
            v-if="!$route.query.draftId && !$route.query.isPost"
            class="statusText"
          >
            {{ detail["n_release_status"] | getStatusName }}
          </span>
          <span
            :class="convertStatusStylePost(parseInt(detail.status))"
            v-if="$route.query.isPost"
            class="statusText"
          >
            {{ parseInt(detail.status) | getStatusNamePost }}
          </span>
          <span> {{ detail[nameSuffix + "title"] }}</span>
        </p>
        <br />
        <p class="time">
          {{
            detail[nameSuffix + "create_time"] ||
            detail[nameSuffix + "publish_time"]
          }}
        </p>
        <p class="author">作者：{{ detail["u_nickname"] }}</p>
        <p class="circle" v-if="detail['circle_name']">
          圈子：<span @click="toCircle()">{{ detail["circle_name"] }}</span>
        </p>
        <br />
        <p class="relations" v-if="detail['relation_resource']">
          关联素材：<span @click="showRelations()"
            >查看（{{ detail["relation_resource"].material.length }}）</span
          >
        </p>
      </div>
      <div class="detailInfoContainer" v-else>
        <p class="title status" style="margin-bottom: 0">
          <span
            :class="convertStatusStyle(detail['n_release_status'])"
            v-if="!$route.query.draftId && !$route.query.isPost"
            class="statusText"
          >
            {{ detail["n_release_status"] | getStatusName }}
          </span>
          <span
            :class="convertStatusStylePost(parseInt(detail.status))"
            v-if="$route.query.isPost"
            class="statusText"
          >
            {{ parseInt(detail.status) | getStatusNamePost }}
          </span>
          <span> {{ detail[nameSuffix + "title"] }}</span>
        </p>
        <p class="time">
          {{
            detail[nameSuffix + "create_time"] ||
            detail[nameSuffix + "publish_time"]
          }}
        </p>
        <p class="author">作者：{{ detail["u_nickname"] }}</p>
        <p class="circle" v-if="detail['circle_name']">
          圈子：<span @click="toCircle()">{{ detail["circle_name"] }}</span>
        </p>
        <br />
        <p class="relations" v-if="detail['relation_resource']">
          关联素材：<span @click="showRelations()"
            >查看（{{ detail["relation_resource"].material.length }}）</span
          >
        </p>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane
          :label="($route.query.isPost ? '帖子' : '稿件') + '详情'"
          name="1"
        >
          <div class="detailContent contentdetail">
            <div
              v-html="detail[nameSuffix + 'content']"
              @click="handleClickDetailHtml"
            ></div>
            <!--文稿类型不展示资源-->
            <div
              v-show="detail[nameSuffix + 'type'] !== 1 && !$route.query.isPost"
              v-for="(item, index) in detail[nameSuffix + 'resource_url']"
              :key="index"
            >
              <p v-if="item.indexOf('.mp4') < 0">
                <img :src="item" class="detailImg" @click="previewimg(item)" />
              </p>
              <p v-else>
                <video
                  :src="item"
                  controls="controls"
                  class="detailVideo"
                  :poster="detail[nameSuffix + 'cover_url'][0]"
                >
                  您的浏览器不支持 video 标签。
                </video>
              </p>
            </div>
            <div v-show="$route.query.isPost">
              <div class="postImgs" v-if="detail.type == 'image'">
                <img
                  v-for="(imgItem, imgIndex) in detail[
                    nameSuffix + 'resource_url'
                  ]"
                  :key="imgIndex"
                  :src="imgItem"
                  @click="previewimg(imgItem)"
                />
              </div>
              <p v-else-if="detail.type == 'video'">
                <video
                  :src="detail[nameSuffix + 'resource_url'][0]"
                  controls="controls"
                  class="detailVideo"
                  :poster="detail[nameSuffix + 'cover_url'][0]"
                >
                  您的浏览器不支持 video 标签。
                </video>
              </p>
            </div>
            <div
              class="linkItem"
              v-if="detail.link_url_info && detail.link_url_info.url"
              @click="handleLink()"
            >
              <div class="imgContain">
                <img
                  :src="linkObj.n_cover_url[0]"
                  class="linkImg"
                  v-if="linkObj.n_cover_url && linkObj.n_cover_url.length"
                />
                <i class="el-icon-link" v-else></i>
              </div>
              <p class="linkName">
                {{ linkObj.n_title || linkObj.url }}
              </p>
            </div>
            <!--文稿类型不展示资源-->
            <div
              class="topicsContainer"
              v-show="
                detail[nameSuffix + 'type'] !== 1 && topicShowList.length > 0
              "
            >
              <p
                v-for="(item, index) in topicShowList"
                :key="index"
                class="topicShow"
                @click="toTopicPage(item.id)"
              >
                {{ item.title }}
              </p>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="操作记录" name="2" v-if="!$route.query.isPost"
          ><div class="detailContent publicScroll">
            <el-timeline class="timeline">
              <el-timeline-item
                v-for="(activity, index) in activities"
                :key="index"
                :color="index == 0 ? '#409EFF' : '#E4E7ED'"
              >
                <p>{{ activity.operation_action }}</p>
                <p>{{ activity.nor_create_time }}</p>
                <p
                  v-if="
                    activity.operation_action.indexOf('提交') >= 0 ||
                    activity.operation_action.indexOf('修改') >= 0 ||
                    activity.operation_action.indexOf('编辑') >= 0 ||
                    activity.operation_action.indexOf('存草稿') >= 0
                  "
                >
                  提交人：{{ activity.u_nickname }}
                </p>
                <p
                  v-if="
                    activity.operation_action.indexOf('审') >= 0 &&
                    activity.operation_action.indexOf('修改') < 0 &&
                    (activity.operation_action.indexOf('人工') >= 0 ||
                      activity.operation_action.indexOf('内审') >= 0) &&
                    (activity.extend.audit_name ||
                      activity.u_nickname != '名称获取不到')
                  "
                >
                  审核人：{{
                    activity.extend.audit_name
                      ? activity.extend.audit_name
                      : activity.u_nickname
                  }}
                </p>
                <p
                  v-if="
                    activity.operation_action.indexOf('审') >= 0 &&
                    activity.extend &&
                    activity.extend.audit_result &&
                    activity.extend.audit_result.indexOf('resource') < 0
                  "
                >
                  审核结果：{{ activity.extend.audit_result }}
                </p>
                <p
                  v-if="
                    activity.operation_action.indexOf('审') >= 0 &&
                    activity.extend &&
                    activity.extend.audit_message &&
                    activity.extend.audit_result.indexOf('不通过') >= 0
                  "
                >
                  原因：{{ activity.extend.audit_message }}
                </p>
                <p
                  v-if="
                    activity.operation_action.indexOf('发布') >= 0 &&
                    activity.operation_action.indexOf('待发布') < 0
                  "
                >
                  发布人：{{ activity.u_nickname }}
                </p>
                <p
                  v-if="
                    activity.operation_action.indexOf('发布') >= 0 &&
                    activity.operation_action.indexOf('待发布') < 0
                  "
                >
                  发布结果：{{ activity.extend.status }}
                </p>
                <p
                  v-if="
                    activity.operation_action.indexOf('发布') >= 0 &&
                    activity.operation_action.indexOf('待发布') < 0
                  "
                >
                  发布平台：{{ activity.extend.platform }}
                </p>
              </el-timeline-item>
            </el-timeline>
          </div>
        </el-tab-pane>
        <el-tab-pane label="修订记录" name="3" v-if="!$route.query.isPost"
          ><div class="detailContent publicScroll">
            <el-button
              type="primary"
              size="small"
              class="diffBtn"
              @click="diffTwoFn"
              >对比（{{ multipleSelection.length }}/2）</el-button
            >
            <el-table
              ref="multipleTable"
              :data="editHistory"
              tooltip-effect="dark"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" width="45"></el-table-column>
              <el-table-column
                prop="nar_create_time"
                label="操作时间"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="operation_name"
                label="动态"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="u_nickname"
                label="操作者"
                align="center"
              ></el-table-column>
              <el-table-column label="修订内容" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    @click="diffOneFn(scope.$index)"
                    >查看</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div></el-tab-pane
        >
        <!-- <el-tab-pane label="发布记录" name="4"
          ><div class="detailContent publicScroll">
            <el-table
              ref="multipleTable"
              :data="publishList"
              tooltip-effect="dark"
            >
              <el-table-column
                prop="nar_create_time"
                label="发布状态"
                align="center"
              >
                <template slot-scope="scope">
                  <div v-html="convertPublishStatus(scope.row)"></div>
                </template>
              </el-table-column>
              <el-table-column
                prop="ab_nickname"
                label="发布门户"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="crs_create_time"
                label="发布时间"
                align="center"
              ></el-table-column>
            </el-table></div
        ></el-tab-pane> -->
      </el-tabs>

      <el-drawer
        title="版本对比"
        :visible.sync="drawerTwo"
        direction="rtl"
        class="drawerTwo"
      >
        <div class="drawerTwoContainer">
          <p class="info">
            {{ newObj.author }}<span>{{ newObj.time }}</span>
          </p>
          <p v-html="newObj.title" class="title"></p>
          <div v-html="newObj.content"></div>
        </div>
        <div class="drawerTwoContainer">
          <p class="info">
            {{ oldObj.author }}<span>{{ oldObj.time }}</span>
          </p>
          <p v-html="oldObj.title" class="title"></p>
          <div v-html="oldObj.content"></div>
        </div>
      </el-drawer>
      <el-drawer
        title="查看"
        :visible.sync="drawerOne"
        direction="rtl"
        class="drawerOne"
      >
        <div class="drawerTwoContainer">
          <p class="info">
            {{ singleObj.author }}<span>{{ singleObj.time }}</span>
          </p>
          <p v-html="singleObj.title" class="title"></p>
          <div v-html="singleObj.content"></div>
        </div>
      </el-drawer>
    </div>

    <el-dialog
      title="发布"
      width="300px"
      :visible.sync="authListShow"
      top="5vh"
    >
      <el-checkbox-group v-model="checkList" class="authListContainer">
        <el-checkbox
          :label="item.ab_openid"
          v-for="(item, index) in authList"
          :key="index"
          >{{ item.ab_user_app | getAppName }}</el-checkbox
        >
      </el-checkbox-group>
      <div slot="footer" class="dialog-footer">
        <el-button @click="authListShow = false">取 消</el-button>
        <el-button type="primary" @click="publishFn">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="查看素材"
      width="740px"
      :visible.sync="materialListShow"
      top="5vh"
      class="materialListContainer"
    >
      <ul>
        <li
          v-for="(item, index) in materialList"
          :key="index"
          @click="toMaterialDetail(item)"
        >
          <img :src="item.cm_icon_url" class="thumb" />
          <p class="title">{{ item.cm_title }}</p>
          <p class="time">{{ item.cm_create_time }}</p>
        </li>
      </ul>
    </el-dialog>
    <audit-modal
      v-if="showAuditModal"
      :result="auditOption.result"
      :id="auditOption.id"
      :on-cancel="() => (this.showAuditModal = false)"
      :on-confirm="confirmAudit"
    />

    <el-dialog
      title="请完成实名认证"
      :visible.sync="certificationVisible"
      class="certificationInfoContainer"
      width="1026px"
    >
      <p class="title">
        应网络实名制要求，完成实名认证后才可以发表文章视频等内容，以保护账号安全。
      </p>
      <div class="borderContainer">
        <div>
          <p class="infoTitle">1、打开“顶端新闻”App</p>
          <p class="info">登录当前账号或扫下方二维码下载“顶端新闻”App</p>
          <img
            src="../../assets/85d81507ebe84f210b224bf8e02c6d76966336a7fff89e02e5f088ed492cce1f.png"
            class="qrCode"
          />
        </div>
        <div>
          <p class="infoTitle">2、打开“我的”</p>
          <p class="info">点击“实名认证”完成实名认证</p>
          <img
            src="../../assets/shiming@2x.png"
            class="app"
            v-if="u_cert != 1"
          />
          <img src="../../assets/shenqing@2x.png" class="app" v-else />
        </div>
      </div>
    </el-dialog>

    <BanDialog
      ref="banShow"
      :isShow="isBanned"
      :allowClose="true"
      @closeBan="isBanned = false"
    ></BanDialog>
  </div>
</template>

<script>
import NavBar from "../../components/NavBar.vue";
import AuditModal from "../../components/audit-modal";
import { diff_match_patch } from "@/utils/diff_match_patch_uncompressed.js";
import {
  RESOURCE_HOST,
  CREATOR_HOST,
  UPLOAD_HOST,
  NEWS_HOST,
  SWNEWS_HOST,
} from "../../constants/apiHosts";
import {
  APP_NAME_MAP,
  POST_LIST_STATUS_DETAIL,
  MANUSCRIPT_LIST_STATUS_DETAIL,
} from "../../constants/manuscript";
import BanDialog from "../../components/banDialog.vue";

export default {
  data() {
    return {
      belong_id: "",
      detailUlr: "",
      deleteUrl: "",
      listName: "",
      jumpPath: "",
      nameSuffix: "",
      detail: {
        relation_resource: {
          material: [],
        },
      },
      activeName: "1",
      activities: [],
      editHistory: [],
      multipleSelection: [],
      multipleSelectionIndex: [],
      contentHistory: [],
      oldObj: {
        title: "",
        content: "",
        author: "",
        time: "",
      },
      newObj: {
        title: "",
        content: "",
        author: "",
        time: "",
      },
      singleObj: {
        title: "",
        content: "",
        author: "",
        time: "",
      },
      drawerTwo: false,
      drawerOne: false,
      noEdit: false,
      authListShow: false,
      authList: [],
      checkList: [],
      hasPublishRight: true,
      publishList: [],
      materialList: [],
      materialListShow: false,
      noAudit: true,
      auditOption: {
        id: "",
        result: "INTERNAL_SUCCESS",
      },
      showAuditModal: false,
      certificationVisible: false,
      u_cert: 0,
      u_cert_status: 0,
      topicShowList: [],
      linkObj: {},
      isBanned: false,
    };
  },
  filters: {
    /**
     * 获取应用门户的名称
     * @param appId 应用门户id
     */
    getAppName: function (appId) {
      return APP_NAME_MAP[appId] || "";
    },
    getStatusName: function (status) {
      return MANUSCRIPT_LIST_STATUS_DETAIL[status] || "审核中";
    },
    getStatusNamePost: function (status) {
      return POST_LIST_STATUS_DETAIL[status] || "审核中";
    },
  },
  components: {
    NavBar,
    AuditModal,
    BanDialog,
  },
  created() {
    if (this.$route.query.isMine) {
      this.belong_id = this.$route.query.scriptId;
      this.detailUlr = "/api/manuscript/show";
      this.deleteUrl = "/api/manuscript/del";
      this.listName = "稿件库";
      this.jumpPath = "/personalScript";
    } else if (this.$route.query.draftId) {
      this.belong_id = this.$route.query.draftId;
      this.detailUlr = "/api/draft/show";
      this.deleteUrl = "/api/draft/del";
      this.listName = "草稿箱";
      this.jumpPath = "/draft";
    } else if (this.$route.query.scriptId) {
      this.belong_id = this.$route.query.scriptId;
      this.detailUlr = "/api/manuscript/show";
      this.deleteUrl = "/api/manuscript/del";
      this.listName = "待审稿库";
      this.jumpPath = "/audit";
    }

    if (this.$route.query.isPost) {
      this.getPostDetail();
    } else {
      this.getDetail();
    }
    this.getUserInfo();
  },
  mounted() {},
  methods: {
    getUserInfo() {
      this.$axios.get(`${SWNEWS_HOST}/api/user/mpBaseUserinfo`).then((res) => {
        if (res.data.code == 0) {
          let u_cert = 0,
            u_cert_status = 0;
          res.data.data.identities_info.forEach((element) => {
            if (element == "identity_verification") {
              u_cert = 1;
            }
            if (
              element == "agency_certification" ||
              element == "professional_certification"
            ) {
              u_cert_status = 1;
            }
          });
          localStorage.setItem("u_cert", u_cert);
          localStorage.setItem("u_cert_status", u_cert_status);

          this.u_cert_status = u_cert_status;
          this.u_cert = u_cert;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getDetail() {
      this.$axios
        .get(
          this.$route.query.isPub == 1
            ? `${SWNEWS_HOST}/api/news/getNewsInfo?id=${this.$route.query.nid}`
            : `${RESOURCE_HOST}${this.detailUlr}?id=${this.belong_id}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            if (res.data.data["n_create_time"]) {
              this.nameSuffix = "n_";
            } else if (res.data.data["nd_create_time"]) {
              this.nameSuffix = "nd_";
            } else if (res.data.data["nm_create_time"]) {
              this.nameSuffix = "nm_";
            }

            if (this.$route.query.isPub == 1) {
              res.data.data.n_release_status = 5;
              res.data.data.nm_title = res.data.data.n_title;
              res.data.data.nm_create_time = res.data.data.n_create_time;
              res.data.data.nm_content = res.data.data.n_content;
              res.data.data.nm_type = res.data.data.n_type;
              res.data.data.nm_resource_url = res.data.data.n_resource_url;
            }
            this.detail = res.data.data;

            this.getActions();
            this.getEditHistory();
            //this.getPublishList();

            if (res.data.data.global_id) {
              this.getTopics(res.data.data.global_id);
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getPostDetail() {
      this.$axios
        .post(`${SWNEWS_HOST}/api/communityPost/getPostDetail`, {
          encode_nid: this.$route.query.nid,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.getMyPostDetail(res.data.data.id);
          } else {
            this.$message.error(res.data.msg || res.data.data);
          }
        });
    },
    getMyPostDetail(id) {
      this.$axios
        .post(`${SWNEWS_HOST}/api/communityMyPost/getMyPostDetail`, {
          id: id,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.nameSuffix = "";

            res.data.data.content = res.data.data.content.replace(
              /\n/g,
              "<br>"
            );

            const regex = /#[^#]+#/g;
            const matches = res.data.data.content.match(regex);
            if (matches) {
              matches.forEach((item) => {
                var regexp = new RegExp(item, "gi");
                res.data.data.content = res.data.data.content.replace(
                  regexp,
                  `<span class="topicName" contenteditable="false">${item}</span>`
                );
              });
            }

            this.detail = res.data.data;

            if (this.detail.link_url_info.url) {
              this.getAnalysisLink(this.detail.link_url_info.url);
            }

            this.$nextTick(() => {
              let topicName = document.getElementsByClassName("topicName");
              for (let i = 0; i < topicName.length; i++) {
                topicName[i].addEventListener("click", () => {
                  this.detail.hottopic_list.forEach((item) => {
                    if (item.title == topicName[i].innerHTML) {
                      let routeData = this.$router.resolve({
                        path: `/theme?id=${item.id}`,
                      });
                      window.open(routeData.href, "_blank");
                    }
                  });
                });
              }
            });
          } else {
            this.$message.error(res.data.msg || res.data.data);
          }
        });
    },
    getAnalysisLink(url) {
      this.$axios
        .post(`${SWNEWS_HOST}/api/communityPost/getAnalysisLink`, {
          url: url,
        })
        .then((res) => {
          if (res.data.code == 0) {
            if (typeof res.data.data.n_cover_url === "string") {
              const str = res.data.data.n_cover_url.trim();
              if (str.startsWith("[") && str.endsWith("]")) {
                try {
                  res.data.data.n_cover_url = JSON.parse(str);
                } catch (e) {}
              }
            }
            this.linkObj = res.data.data;
          } else {
            this.$message.error(res.data.msg || res.data.data);
          }
        });
    },
    handleLink() {
      if (this.linkObj.url) {
        window.open(this.linkObj.url);
      } else if (this.linkObj.n_id) {
        window.open(
          (window.location.href.indexOf("topnews.cn") >= 0 ||
          window.location.href.indexOf("topnews.cn") >= 0
            ? "https://m.topnews.cn"
            : "https://m.dingnews.net") +
            "/news/" +
            id
        );
      }
    },
    convertPublishStatus(item) {
      let status = item.crs_result;
      if (status == 0) {
        return "<span style='color: #FF9E17;'>发布中</span>";
      } else if (status == 1) {
        return `<span style='color: #9CD00B;'>发布成功</span>`;
      } else if (status == 2) {
        return "<span style='color: red;'>发布失败</span>";
      }
    },
    showRelations() {
      //素材
      if (
        this.detail.relation_resource &&
        this.detail.relation_resource.material.length
      ) {
        this.$axios
          .post(`${RESOURCE_HOST}/api/material/list`, {
            all: 1,
            per_page: 50,
            page: 1,
            cm_id: this.detail.relation_resource.material.join(","),
          })
          .then((res) => {
            if (res.data.code == 0) {
              this.materialList = res.data.data.data;

              this.materialListShow = true;
            } else {
              this.$message.error(res.data.msg);
            }
          });
      }
    },
    toMaterialDetail(item) {
      let routeUrl = this.$router.resolve({
        path: "/material/detail",
        query: {
          materialId: item.cm_id,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    getActions() {
      this.$axios
        .get(
          `${RESOURCE_HOST}/api/articlerecord/operationrecord?type=${
            this.detail[this.nameSuffix + "type"]
          }&page=1&size=50&global_id=${this.detail.global_id}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            this.activities = res.data.data;
          } else if (res.data.msg == "未找到应用或用户") {
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getEditHistory() {
      this.$axios
        .get(
          `${RESOURCE_HOST}/api/articlerecord/search?type=${
            this.detail[this.nameSuffix + "type"]
          }&page=1&size=50&global_id=${this.detail.global_id}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            if (res.data.data.returnData.length) {
              res.data.data.returnData[0].nar_create_time = "";
              this.editHistory = res.data.data.returnData;
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getContentHistory(first_id, second_id, index, openType) {
      this.$axios
        .get(
          second_id
            ? `${RESOURCE_HOST}/api/articlerecord/diff?first_id=${first_id}&second_id=${second_id}&global_id=${this.detail.global_id}`
            : `${RESOURCE_HOST}/api/articlerecord/diff?first_id=${first_id}&global_id=${this.detail.global_id}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            if (first_id == second_id) {
              this.diffFn(res.data.data.articles[0], res.data.data.articles[0]);
            } else if (second_id) {
              this.diffFn(res.data.data.articles[0], res.data.data.articles[1]);
            }

            if (openType) {
              this.drawerTwo = true;
            } else {
              this.drawerOne = true;
            }
          } else if (res.data.msg == "稿件未进行修改") {
            this.noEdit = true;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    diffTwoFn() {
      if (this.multipleSelection.length != 2) {
        this.$message({
          message: "请选择两篇文章进行对比",
          type: "warning",
        });
      } else if (this.noEdit) {
        this.$message({
          message: "稿件未进行修改",
          type: "warning",
        });
      } else {
        this.getContentHistory(
          this.multipleSelection[0].nar_id,
          this.multipleSelection[1].nar_id,
          0,
          1
        );
      }
    },
    diffOneFn(index) {
      if (this.noEdit) {
        this.singleObj = {
          title: this.detail[this.nameSuffix + "title"],
          content: this.detail[this.nameSuffix + "content"]
            .split("<body>")[1]
            .split("</body>")[0],
          author: this.detail.u_nickname,
          time: this.editHistory[index].nar_create_time,
        };
      } else if (index == this.editHistory.length - 1) {
        this.getContentHistory(
          this.editHistory[index].nar_id,
          this.editHistory[index].nar_id,
          index,
          0
        );
      } else {
        this.getContentHistory(
          this.editHistory[index].nar_id,
          this.editHistory[this.editHistory.length - 1].nar_id,
          index,
          0
        );
      }
    },
    diffFn(content0, content1) {
      let dmp1 = new diff_match_patch();
      dmp1.Diff_Timeout = 0;
      let d1 = dmp1.diff_main(content1.nar_title, content0.nar_title, false);

      let dmp2 = new diff_match_patch();
      dmp2.Diff_Timeout = 0;
      let d2 = dmp2.diff_main(
        this.HTMLDecode(
          content1.nar_content.indexOf("<body>") >= 0
            ? content1.nar_content.split("<body>")[1].split("</body>")[0]
            : content1.nar_content
        ),
        this.HTMLDecode(
          content0.nar_content.indexOf("<body>") >= 0
            ? content0.nar_content.split("<body>")[1].split("</body>")[0]
            : content0.nar_content
        ),
        false
      );

      this.newObj = {
        title: dmp1.diff_prettyHtml(d1),
        content: dmp2
          .diff_prettyHtml(d2)
          .replaceAll("&para;", "")
          .replace("<br>", ""),
        author: content0.u_nickname,
        time: content0.nar_create_time,
      };
      this.oldObj = {
        title: content1.nar_title,
        content:
          content1.nar_content.indexOf("<body>") >= 0
            ? content1.nar_content.split("<body>")[1].split("</body>")[0]
            : content1.nar_content,
        author: content1.u_nickname,
        time: content1.nar_create_time,
      };
      this.singleObj = {
        title: dmp1.diff_prettyHtml(d1),
        content: dmp2
          .diff_prettyHtml(d2)
          .replaceAll("&para;", "")
          .replace("<br>", ""),
        author: content0.u_nickname,
        time: content0.nar_create_time,
      };
    },
    HTMLDecode(text) {
      var temp = document.createElement("div");
      temp.innerHTML = text;
      var output = temp.innerText || temp.textContent;
      temp = null;
      return output;
    },
    getPublishList() {
      this.$axios
        .post(`${CREATOR_HOST}/creator/release/newsRelease`, {
          global_id: this.detail.global_id,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.publishList = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    convertStatus(status, auditStatus, publishType, push) {
      if (this.$route.query.scriptId && !this.$route.query.isMine) {
        if (
          auditStatus == 3 ||
          status == 5 ||
          status == 6 ||
          status == 7 ||
          auditStatus == 1
        ) {
          return `<span style='color: #9CD00B;border: 1px solid #9CD00B;'>内审通过</span>`;
        } else if (auditStatus == 1) {
          return "<span style='color: #FF9E17;border: 1px solid #FF9E17;'>内审中</span>";
        } else if (auditStatus == 2 || status == 3) {
          return "<span style='color: red;border: 1px solid red;'>内审不通过</span>";
        } else {
          return "<span style='color: #FF9E17;border: 1px solid #FF9E17;'>内审中</span>";
        }
      } else if (this.$route.query.scriptId) {
        if (status == 0) {
          return `<span style='color: #9CD00B;border: 1px solid #9CD00B;'>待审核</span>`;
        } else if (status == 1) {
          return "<span style='color: #FF9E17;border: 1px solid #FF9E17;'>内审中</span>";
        } else if (status == 2) {
          return "<span style='color: #FF9E17;border: 1px solid #FF9E17;'>中台审核中</span>";
        } else if (status == 3) {
          return "<span style='color: red;border: 1px solid red;'>内审不通过</span>";
        } else if (status == 4) {
          return "<span style='color: red;border: 1px solid red;'>中台审核不通过</span>";
        } else if (status == 5) {
          return "<span style='color: #FF9E17;border: 1px solid #FF9E17;'>待发布</span>";
        } else if (
          push &&
          push.count.total >= push.count.success &&
          push.count.success > 0
        ) {
          return `<span style='color: #9CD00B;border: 1px solid #9CD00B;'>已发布(${push.count.success}/${push.count.total})</span>`;
        } else if (!push && status == 7) {
          return `<span style='color: #9CD00B;border: 1px solid #9CD00B;'>已发布</span>`;
        } else if (push && push.count.total > 0 && push.count.success == 0) {
          return "<span style='color: red;border: 1px solid red;'>发布失败</span>";
        } else {
          return "<span style='color: #FF9E17;border: 1px solid #FF9E17;'>中台审核中</span>";
        }
      }
    },
    toEdit() {
      if (this.u_cert != 1) {
        this.certificationVisible = true;
        return;
      }
      let banData = localStorage.getItem("banData");
      if (banData) {
        banData = JSON.parse(banData);
      }
      if (banData.ban_type == 1 && banData.ban_range_type.indexOf("1") > -1) {
        this.$refs.banShow.getReason(localStorage.getItem("token"));
        this.isBanned = true;
        return;
      }
      if (this.detail[this.nameSuffix + "type"] == 1) {
        let routeData = this.$router.resolve({
          path: "/scriptWrite",
          query: this.$route.query,
        });
        window.open(routeData.href, "_blank");
      } else if (this.detail[this.nameSuffix + "type"] == 2) {
        let routeData = this.$router.resolve({
          path: "/videoWrite",
          query: this.$route.query,
        });
        window.open(routeData.href, "_blank");
      } else if (this.detail[this.nameSuffix + "type"] == 3) {
        let routeData = this.$router.resolve({
          path: "/graphWrite",
          query: this.$route.query,
        });
        window.open(routeData.href, "_blank");
      }
    },
    toEditPost() {
      let banData = localStorage.getItem("banData");
      if (banData) {
        banData = JSON.parse(banData);
      }
      if (banData.ban_type == 1 && banData.ban_range_type.indexOf("3") > -1) {
        this.$refs.banShow.getReason(localStorage.getItem("token"));
        this.isBanned = true;
        return;
      }
      let routeData = this.$router.resolve({
        path: "/post",
        query: {
          nid: this.detail.encode_nid,
        },
      });
      window.open(routeData.href, "_blank");
    },
    publishShow() {
      if (this.u_cert != 1) {
        this.certificationVisible = true;
        return;
      }
      this.checkList = [];
      this.authListShow = true;
    },
    publishFn() {
      if (this.checkList.length == 0) {
        this.$message({
          message: "请选择发布渠道",
          type: "warning",
        });
        return;
      }
      let channels = [];
      this.authList.forEach((item) => {
        this.checkList.forEach((item1) => {
          if (item.ab_openid == item1) {
            channels.push(item.ab_user_app);
          }
        });
      });
      this.$axios
        .post(`${CREATOR_HOST}/creator/channel/push`, {
          channels: channels.join(","),
          open_ids: this.checkList.join(","),
          cr_id: this.detail[this.nameSuffix + "id"],
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.authListShow = false;

            this.$message({
              message: "发文推送完成",
              type: "success",
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    republishFn(item) {
      let open_ids = "";
      this.authList.forEach((item) => {
        if (item.ab_user_app == item.crs_channel) {
          open_ids = item.ab_openid;
        }
      });
      this.$axios
        .post(`${CREATOR_HOST}/creator/channel/push`, {
          channels: item.crs_channel,
          open_ids: open_ids,
          cr_id: this.detail[this.nameSuffix + "id"],
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.getPublishList();

            this.$message({
              message: "发文推送完成",
              type: "success",
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    cancelAudit() {
      if (this.u_cert != 1) {
        this.certificationVisible = true;
        return;
      }
      this.$confirm("确定要撤回该篇文稿的审核吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`${RESOURCE_HOST}/api/manuscript/reset`, {
              id: this.detail[this.nameSuffix + "id"],
            })
            .then((res) => {
              if (res.data.code == 0) {
                this.$message({
                  message: "撤回成功",
                  type: "success",
                });

                this.$router.push({
                  path: "/draft",
                });
              } else {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {});
    },
    toDelete() {
      if (this.u_cert != 1) {
        this.certificationVisible = true;
        return;
      }
      this.$confirm("确定要删除该篇文稿吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(
              this.$route.query.isPub == 1
                ? `${NEWS_HOST}/api/news/del`
                : `${RESOURCE_HOST}${this.deleteUrl}`,
              {
                ids:
                  this.$route.query.isPub == 1
                    ? this.detail["n_id"] + ""
                    : this.detail[this.nameSuffix + "id"] + "",
                global_ids: this.detail.global_id,
              }
            )
            .then((res) => {
              if (res.data.code == 0) {
                this.$message({
                  message: "删除成功",
                  type: "success",
                });

                this.$router.push({
                  path: this.jumpPath,
                });
              } else {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {});
    },
    toDeletePost() {
      this.$confirm("确定要删除该篇帖子吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`${SWNEWS_HOST}/api/communityMyPost/delPost`, {
              post_id: this.detail.id,
            })
            .then((res) => {
              if (res.data.code == 0) {
                this.$message({
                  message: "删除成功",
                  type: "success",
                });

                this.$router.push({
                  path: "/personalScript",
                });
              } else {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {});
    },
    /**
     * 展开审核弹框
     * @param status
     */
    handleAudit(status) {
      if (this.u_cert != 1) {
        this.certificationVisible = true;
        return;
      }
      this.auditOption.id = this.detail.nm_id;
      this.auditOption.result = status;
      this.showAuditModal = true;
    },
    // 审核完成之后的操作
    confirmAudit: function () {
      this.showAuditModal = false;
      this.noAudit = false;
      this.$router.push({
        path: "/scriptDetail",
        query: {
          scriptId: this.detail.nm_id,
        },
      });

      this.getDetail();
    },
    convertStatusStyle(status) {
      switch (status) {
        case 1:
        case 2:
          return "info";
        case 3:
        case 4:
          return "info";
        case 5:
          return "success";
        case 8:
          return "error";
        default:
          return "info";
      }
    },
    convertStatusStylePost(status) {
      switch (status) {
        case 1:
          return "success";
        case 3:
          return "error";
        default:
          return "info";
      }
    },
    handleClickDetailHtml(e) {
      if (e.target.tagName == "IMG") {
        this.$hevueImgPreview(e.target.src);
      }
    },
    previewimg(url) {
      this.$hevueImgPreview(url);
    },
    getTopics(global_id) {
      this.$axios
        .get(
          `${NEWS_HOST}/api/hottopic/getTopicListByManuscriptId?global_id=${global_id}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            this.topicShowList = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    toTopicPage(id) {
      window.open(
        (window.location.href.indexOf("topnews.cn") >= 0 ||
        window.location.href.indexOf("topnews.cn") >= 0
          ? "https://m.topnews.cn"
          : "https://m.dingnews.net") +
          "/theme/" +
          id
      );
    },
    pubNow() {
      this.$confirm("立即发布这篇文章吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`${RESOURCE_HOST}/api/manuscript/sendNow`, {
              nm_id: this.belong_id + "",
            })
            .then((res) => {
              if (res.data.code == 0) {
                this.$message({
                  message: "发布成功",
                  type: "success",
                });

                this.getDetail();
              } else {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {});
    },
    toCircle() {
      window.open(
        (window.location.href.indexOf("topnews.cn") >= 0 ||
        window.location.href.indexOf("topnews.cn") >= 0
          ? "https://m.topnews.cn"
          : "https://m.dingnews.net") +
          "/c/circle-share-new?circleId=" +
          this.detail.community_circle_id
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables";

.mainContainer {
  background-color: #edf1f8;

  .innerContainer {
    width: 1024px;
    min-height: calc(100vh - 84px);
    margin: 0 auto;

    .el-breadcrumb {
      line-height: 50px;
      display: inline-block;
    }

    .el-dropdown {
      float: right;
      margin-top: 9px;
    }

    .detailInfoContainer {
      width: 100%;
      padding: 15px 20px 20px 20px;
      background-color: #ffffff;
      box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

      .status {
        span {
          font-size: 14px;
          font-weight: 400;
          border-radius: 4px;
          display: inline-block;
          line-height: 14px;
        }
        @include status();

        .statusText {
          padding: 3px 12px;
          margin-right: 10px;
        }
      }

      .title {
        font-size: 16px;
        font-weight: 400;
        margin-bottom: 12px;
        display: inline-block;
        line-height: 26px;
      }

      .time,
      .author,
      .circle {
        display: inline-block;
        margin-right: 20px;
        color: #666666;
        font-size: 14px;

        span {
          color: #5574e7;
          cursor: pointer;
        }
      }

      .relations {
        display: inline-block;
        margin: 8px 20px 0 0;

        span {
          color: #409eff;
          cursor: pointer;
        }
      }
    }

    .el-tabs {
      margin-top: 10px;
      /*height: calc(100% - 165px);*/

      /deep/.el-tabs__header {
        margin-bottom: 0;
      }

      /deep/.el-tabs__nav-wrap::after {
        height: 0;
      }

      /deep/.el-tabs__content {
        width: 100%;
        //height: calc(100% - 40px);
        background-color: #ffffff;

        .el-tab-pane {
          .detailContent {
            padding: 20px;
            font-size: 18px;
            color: #333;
            line-height: 1.71;

            .timeline {
              margin: 20px 0 0 30px;

              p {
                line-height: 20px;
              }
            }

            .diffBtn {
              margin-bottom: 10px;
            }

            .topicName {
              color: #1687d9 !important;
              margin-right: 6px !important;
              cursor: pointer;
            }

            .postImgs {
              display: flex;
              flex-wrap: wrap;

              img {
                width: 145px;
                height: 145px !important;
                margin: 15px 18px 0 0 !important;

                &:nth-child(3n) {
                  margin-right: 0 !important;
                }
              }
            }

            .linkItem {
              width: 100%;
              max-width: 400px;
              padding: 8px;
              margin-top: 8px;
              background-color: #f8f8f8;
              display: flex;
              align-items: center;
              box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.1);
              border-radius: 6px;
              cursor: pointer;

              .imgContain {
                width: 60px;
                height: 60px;
                background-color: #ededed;
              }

              i {
                font-size: 60px;
                color: #cccccc;
              }

              .linkImg {
                width: 60px;
                height: 60px !important;
                background-color: #ededed;
                object-fit: cover;
              }

              .linkName {
                width: calc(100% - 60px);
                padding-left: 12px;
                margin: 0;
                font-size: 16px;
                color: #333;
                line-height: 24px;
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                word-break: break-all;
              }
            }
          }

          .content {
            * {
              max-width: 100% !important;
              box-sizing: border-box !important;
              -webkit-box-sizing: border-box !important;
            }

            img,
            video {
              height: auto !important;
              max-height: 500px !important;
              margin: 0 auto !important;
              max-width: 100% !important;
              display: block;
            }

            video {
              width: 100% !important;
            }

            p {
              font-size: 18px !important;
              color: #333;
              line-height: 1.7 !important;
              letter-spacing: 0.8px !important;
              word-break: break-all;
              letter-spacing: 0.8px !important;
              margin-top: 15px;
              max-width: 100% !important;
              overflow-x: hidden;
            }

            span {
              font-size: 18px !important;
              color: #333;
              line-height: 1.71 !important;
            }

            div {
              width: 100% !important;
              height: 100% !important;
              font-size: 18px !important;
              color: #333;
              line-height: 1.7 !important;
              letter-spacing: 0.8px !important;
              max-width: 100% !important;
            }

            section {
              font-size: 18px !important;
              color: #333;
              line-height: 1.7 !important;
              letter-spacing: 0.8px !important;
              max-width: 100% !important;
              overflow-x: hidden;
              //text-indent: 0 !important;
              margin-top: 15px;
            }

            a {
              text-decoration: underline;
            }

            figure.image {
              margin: 15px 0 0 0;
            }

            figure.image figcaption {
              color: #999;
              display: block;
              margin-top: 0.25em;
              text-align: center;
              font-size: 16px;
            }
          }
        }
      }
    }
  }

  /deep/.el-drawer {
    .el-drawer__body {
      display: flex;
    }

    .el-drawer__header {
      margin-bottom: 10px;
    }

    .drawerTwoContainer {
      width: 100%;
      border-right: 1px solid #ebeef5;
      padding: 10px;

      .info {
        font-size: 16px;
        font-weight: bold;
        background-color: #f0f2f5;
        padding: 5px;
        margin-bottom: 15px;

        span {
          font-size: 14px;
          font-weight: normal;
          margin-left: 20px;
          display: inline-block;
        }
      }

      .title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
      }

      div {
        line-height: 20px;
      }
    }
  }

  /deep/.drawerTwo {
    .el-drawer {
      width: 800px !important;
    }
  }

  /deep/.drawerOne {
    .el-drawer {
      width: 400px !important;
    }
  }

  .authListContainer {
    display: inline-flex;
    flex-direction: column;
    margin-left: 70px;

    .el-checkbox {
      margin: 5px 0;
    }
  }

  /deep/.materialListContainer {
    .el-dialog__header {
      padding-bottom: 0;
    }

    .el-dialog__body {
      padding-top: 0;

      ul {
        display: flex;

        li {
          width: 160px;
          margin: 20px 20px 0 0;
          cursor: pointer;

          .title {
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            line-height: 20px;
          }

          .time {
            line-height: 20px;
          }
        }

        li:nth-child(4n) {
          margin-right: 0;
        }
      }
    }
  }

  /deep/ .el-table__header-wrapper .el-checkbox {
    display: none;
  }

  .certificationInfoContainer {
    /deep/.el-dialog__header {
      padding: 20px 32px;

      .el-dialog__title {
        font-size: 16px;
        font-family: PingFang-SC-Heavy, PingFang-SC;
        font-weight: 800;
        color: #333333;
        line-height: 22px;
      }
    }

    /deep/.el-dialog__body {
      padding: 10px 32px 41px 32px;

      .title {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        margin-bottom: 20px;
      }

      .borderContainer {
        height: 255px;
        border-radius: 6px;
        border: 1px solid #dcdfe6;
        display: flex;
        padding: 28px 32px 0 32px;
        justify-content: space-between;

        div {
          flex: 1;

          .infoTitle {
            font-size: 16px;
            font-family: PingFang-SC-Heavy, PingFang-SC;
            font-weight: 800;
            color: #333333;
            line-height: 22px;
            margin-bottom: 10px;
          }

          .info {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 22px;
          }

          .qrCode {
            width: 118px;
            margin: 22px 0 0 117px;
          }

          .app {
            width: 198px;
            margin: 20px 0 0 43px;
          }
        }
      }
    }
  }
}

/deep/ .contentdetail {
  width: 50%;
  margin: 0 auto;
  * {
    max-width: 100% !important;
    box-sizing: border-box !important;
    -webkit-box-sizing: border-box !important;
  }

  img,
  video {
    height: auto !important;
    //min-height: 100px !important;
    margin: 0 auto !important;
    max-width: 100% !important;
    display: block;
  }

  video {
    width: 100% !important;
  }

  img {
    cursor: pointer;
  }

  p {
    font-size: 18px !important;
    color: #333;
    line-height: 1.7 !important;
    letter-spacing: 0.8px !important;
    word-break: break-all;
    letter-spacing: 0.8px !important;
    margin-top: 15px;
  }

  span {
    font-size: 18px !important;
    color: #333;
    line-height: 1.71 !important;
  }

  div {
    height: 100% !important;
    font-size: 18px !important;
    color: #333;
    line-height: 1.7 !important;
    letter-spacing: 0.8px !important;
    max-width: 100% !important;
  }

  section {
    font-size: 18px !important;
    color: #333;
    line-height: 1.7 !important;
    letter-spacing: 0.8px !important;
    max-width: 100% !important;
    margin-top: 15px;
  }

  a {
    text-decoration: underline;
  }

  figure.image {
    margin: 15px 0 0 0;
  }

  figure.image figcaption {
    color: #999;
    display: block;
    margin-top: 0.25em;
    text-align: center;
    font-size: 16px;
  }

  .topicsContainer {
    display: flex;
    flex-wrap: wrap;

    .topicShow {
      line-height: 23px !important;
      background: #e8ecff;
      border-radius: 11px;
      color: #5371f3;
      font-size: 14px !important;
      margin-right: 10px !important;
      padding: 0 8px !important;
      cursor: pointer;
    }
  }
}
</style>
